import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    isRemoveProjectFromPortfolioRequestFailure(portfolio, project) {
      const req = getState().find(
        (req) =>
          req.portfolio.uuid === portfolio.uuid &&
          req.project.uuid === project.uuid,
      );

      return req ? req.request.isFailure : false;
    },
    isRemoveProjectFromPortfolioRequestPending(portfolio, project) {
      const req = getState().find(
        (req) =>
          req.portfolio.uuid === portfolio.uuid &&
          req.project.uuid === project.uuid,
      );

      return req ? req.request.isPending : false;
    },
    isRemoveProjectFromPortfolioRequestSuccess(portfolio, project) {
      const req = getState().find(
        (req) =>
          req.portfolio.uuid === portfolio.uuid &&
          req.project.uuid === project.uuid,
      );

      return req ? req.request.isSuccessful : false;
    },
  };
}

export { createSelector };
